import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { HHFormCheckboxField } from 'components/form-fields/v5'
import { FormControlLabel, Grid, Stack, Tooltip, Typography } from '@mui/material'
import T from 'T'
import { get } from 'lodash'

const FormDayOfWeekCheckboxField = ({ day, label, isCompact = false }) => {
  const { control, watch, setValue } = useFormContext()
  const dayKey = day
  const dayAbbreviation = day?.substring(0, 3)
  const dayLabel = label ?? dayAbbreviation
  const daysOfWeek = watch('daysOfWeek')
  const recurrenceFrequency = watch('recurrenceFrequency')
  const daysOfWeekRequiredCountSelected = useMemo(() => {
    return (
      Object.values(daysOfWeek || {})?.filter(d => {
        return d?.isSelected || false
      }).length === parseInt(recurrenceFrequency, 10)
    )
  })
  const disableDaySelection = daysOfWeekRequiredCountSelected && daysOfWeek[dayKey]?.isSelected === false
  const disableRequired = get(daysOfWeek, `${dayKey}.isSelected`, false) === false

  const handleDaySelectionChange = event => {
    if (event.target.checked === false) {
      setValue(`daysOfWeek.${dayKey}.isRequired`, false)
    }
  }

  const renderLabel = (text, color = 'text.primary') => (
    <Tooltip title={text} arrow placement="top">
      <Typography variant="caption" color={color} sx={{ maxWidth: 45, display: 'block' }} noWrap>
        {text}
      </Typography>
    </Tooltip>
  )

  if (isCompact) {
    return (
      <Grid item key={day} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Stack direction="column">
          <FormControlLabel
            value={dayAbbreviation}
            control={
              <HHFormCheckboxField
                onChange={handleDaySelectionChange}
                name={`daysOfWeek.${dayKey}.isSelected`}
                control={control}
                disabled={disableDaySelection}
                size="small"
              />
            }
            label={renderLabel(dayLabel)}
            disabled={disableDaySelection}
            labelPlacement="bottom"
            sx={{ mx: 0 }}
          />
          <FormControlLabel
            value="required"
            label={renderLabel(T.REQUIRED, 'text.secondary')}
            disabled={disableRequired}
            labelPlacement="bottom"
            control={<HHFormCheckboxField name={`daysOfWeek.${dayKey}.isRequired`} control={control} disabled={disableRequired} size="small" />}
            sx={{ mx: 0 }}
          />
        </Stack>
      </Grid>
    )
  }

  return (
    <Grid item key={day} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Stack direction="column">
        <FormControlLabel
          value={dayAbbreviation}
          control={
            <HHFormCheckboxField
              onChange={handleDaySelectionChange}
              name={`daysOfWeek.${dayKey}.isSelected`}
              control={control}
              disabled={disableDaySelection}
            />
          }
          label={dayLabel}
          disabled={disableDaySelection}
          labelPlacement="bottom"
          slotProps={{
            typography: {
              variant: 'caption',
              color: 'text.primary',
            },
          }}
        />
        <FormControlLabel
          value="required"
          label={T.REQUIRED}
          disabled={disableRequired}
          labelPlacement="bottom"
          control={<HHFormCheckboxField name={`daysOfWeek.${dayKey}.isRequired`} control={control} disabled={disableRequired} />}
          slotProps={{
            typography: {
              variant: 'caption',
              color: 'text.secondary',
            },
          }}
        />
      </Stack>
    </Grid>
  )
}

FormDayOfWeekCheckboxField.propTypes = {
  day: PropTypes.string.isRequired,
  label: PropTypes.string,
  isCompact: PropTypes.bool,
}

export default FormDayOfWeekCheckboxField
